


















































































































































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component({
  components: {}
})
export default class AiAdvicePlans extends Vue {
  private stageList: any = []
  private nowStage: any = {
    stage_date: 0,
    growth_step: 0,
    growth_stage_name: '-'
  }
  private nextStage: any = {
    stage_date: 0,
    growth_step: 0,
    growth_stage_name: '-'
  }
  private nowPlan: any = {
    fertilization: null,
    id: 0,
    observation: null,
    risk: null,
    variety_stage_step: 0,
    watering: null
  }
  private nextPlan: any = {
    fertilization: null,
    id: 0,
    observation: null,
    risk: null,
    variety_stage_step: 0,
    watering: null
  }

  @Prop() private aiAdvicePlans!: any
  @Prop() private aiAdviceName!: any

  private get aiAdviceChangeState (): any {
    return this.aiAdvicePlans
  }

  private get dateChangeState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }

  private get stageUpdated (): number {
    return this.$store.state.fieldDetailsState.stageData
  }

  @Watch('stageUpdated')
  changeAdvice (data: any) {
    this.stageList = data
  }

  @Watch('aiAdviceChangeState')
  onAiAdviceChange (plans: any) {
    this.aiAdvicePlans = plans
    this.changeAiAdvice()
  }

  @Watch('dateChangeState')
  onDateChange (newValue: string) {
    for (let i in this.stageList) {
      if (i === '0' && newValue <= this.stageList[i].stage_date) {
        this.nowStage = this.stageList[i]
        this.nextStage = this.stageList[parseInt(i) + 1]
        this.changeAiAdvice()
        break
      }

      if (parseInt(i) === (this.stageList.length - 1) && newValue >= this.stageList[i].stage_date) {
        this.nowStage = this.stageList[i]
        this.nextStage = {
          stage_date: 0,
          growth_step: 0,
          growth_stage_name: '-'
        }
        this.changeAiAdvice()
        break
      }

      if (newValue >= this.stageList[i].stage_date && newValue < this.stageList[parseInt(i) + 1].stage_date) {
        this.nowStage = this.stageList[i]
        this.nextStage = this.stageList[parseInt(i) + 1]
        this.changeAiAdvice()
        break
      }
    }
  }

  created () {
    this.stageList = this.$store.state.fieldDetailsState.stageData
  }

  private displayValue (value: string|null) {
    return value === '' || value === null || value === undefined ? '-' : value
  }

  private changeAiAdvice () {
    // リセット
    this.nowPlan = {
      fertilization: null,
      id: 0,
      observation: null,
      risk: null,
      variety_stage_step: 0,
      watering: null
    }
    this.nextPlan = {
      fertilization: null,
      id: 0,
      observation: null,
      risk: null,
      variety_stage_step: 0,
      watering: null
    }

    // AIアドバイスがあればセット
    for (let i in this.aiAdvicePlans) {
      if (this.nowStage.growth_step !== 0 && this.aiAdvicePlans[i].variety_stage_step === this.nowStage.growth_step) {
        this.nowPlan = this.aiAdvicePlans[i]
      }
      if (this.nextStage.growth_step !== 0 && this.aiAdvicePlans[i].variety_stage_step === this.nextStage.growth_step) {
        this.nextPlan = this.aiAdvicePlans[i]
      }
    }
  }
}
